import React from 'react';
import { string, number } from 'prop-types';

import * as helpers from './helpers';

const InProgressIcon = ({ color, fillOpacity, ...props }) => (
  <svg {...helpers.getSvgDimensionsProps(props)} {...props}>
    <path
      d="M10.5002 0.166748C4.771 0.166748 0.0834961 4.85425 0.0834961 10.5834C0.0834961 16.3126 4.771 21.0001 10.5002 21.0001C16.2293 21.0001 20.9168 16.3126 20.9168 10.5834C20.9168 4.85425 16.2293 0.166748 10.5002 0.166748ZM10.5002 18.9167C5.90641 18.9167 2.16683 15.1772 2.16683 10.5834C2.16683 5.98967 5.90641 2.25008 10.5002 2.25008C15.0939 2.25008 18.8335 5.98967 18.8335 10.5834C18.8335 15.1772 15.0939 18.9167 10.5002 18.9167ZM15.2814 5.97925L8.41683 12.8438L5.71891 10.1563L4.25016 11.6251L8.41683 15.7917L16.7502 7.45842L15.2814 5.97925Z"
      fill={color}
      stroke={color}
      strokeWidth={0.3}
    />
  </svg>
);

InProgressIcon.propTypes = {
  fillOpacity: number,
  color: string.isRequired,
  ...helpers.iconDimensionsPropTypes,
};

InProgressIcon.defaultProps = {
  fillOpacity: 0.4,
  ...helpers.getDefaultIconDimensionsProps(21, 21),
};

export default InProgressIcon;



// WEBPACK FOOTER //
// ./src/components/svg-icon/icons/in-progress.js